<template>
    <div class="body">
        <p  class="font1" style="padding-top: 13vh;">志向高远，心之所向</p>
        <p  class="font1" style="padding-top: 1vh;">脚踏实地，步步为营</p>

        <p class="font2" style="padding-top: 4vh;">今年你在富学宝典上累计考试<a class="font3">{{ ReportData.examTimes }}</a>次</p>
        <p class="font2">其中一次通过考试的课程有<a class="font3">{{ ReportData.coursenumF }}</a>门</p>
        <p class="font2">超越了<a class="font3">{{ ReportData.rate4 }}</a>%的小伙伴！</p>
        <p class="font2" style="padding-top: 1vh;">你今年获得总学分<a class="font3">{{ ReportData.creditvalue}}</a>分</p>

        <div style="width: 90%;height: 30vh;margin-top: 3vh;background-color: rgba(255, 255, 255, 0.5);border-radius: 10px;">
          <v-chart :option="chartOne" autoresize></v-chart>
        </div>
    </div>
</template>
  
<script>
import { use } from 'echarts/core'
import { PieChart} from 'echarts/charts'
import {GridComponent} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import VChart, { THEME_KEY } from "vue-echarts"
use([ GridComponent, PieChart, CanvasRenderer])
export default {
    props: ["ReportData"],
    components: {
        VChart
    },
    data() {
        return {
			chartOne:{
				series:[
					{
						type:'pie',
						radius: '50%', 
						data:[],
					}
				]
			}
        }
    }, 
    computed:{
		totalScore(){
			const array=JSON.parse(this.ReportData.creditvalueRate)
			const pieChartData = Object.entries(array).filter(([name, value]) => value !== 0).map(([name, value]) => ({
			value: value,
			name: name,
			itemStyle: {
				color: this.getColorByName(name),
			},
			}));

			this.$set(this.chartOne.series[0], 'data', pieChartData);

			return array;
		}
    },
    methods:{
      getColorByName(name) {
      // Define a function to map names to colors
      // You can customize this based on your preferences
      const colorMap = {
        线下: '#fae6a2',
        讲师: 'rgb(116, 203, 184)',
        富学宝典: '#f5c163',
        // Add more entries as needed
      };

      return colorMap[name] || 'red'; // Default color for unknown names
    },
    },
    created(){
     this.totalScore
    }
  }
  </script>
  
<style scoped>
  .body {
    background:url("../../assets/24year/bg2.jpg")  no-repeat;
    background-size: 100% 100%,cover;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;  
    align-items: center;  
}
  .font1 {
    width: 90%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    color: #fff;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 80%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #fff;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #953b5d;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
  </style>